// extracted by mini-css-extract-plugin
export default {"page":"src-pages-404__page","background":"src-pages-404__background","foreground":"src-pages-404__foreground","back":"src-pages-404__back"};